

module.exports = __webpack_require__.stylable.create(
    "GroupTitleLink2806496182",
    {"classes":{"root":"GroupTitleLink2806496182__root","link":"GroupTitleLink2806496182__link"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "GroupTitleLink2806496182",
    null
);
